if($('.type-detail').length){
    if($('.p-final-price-wrapper .price-additional>span').length){
        $('.p-final-price-wrapper .price-additional>span').each(function () {
                const html = $(this).html();
                const updated = html.replace(bezDPH, '<small>'+bezDPH+'</small>').replace(od, '<small>'+od+'</small>');
                $(this).html(updated);
        });
        $('.p-final-price-wrapper .price-final>span').each(function () {
                const html = $(this).html();
                const updated = html.replace(od, '<small>'+od+'</small>');
                $(this).html(updated);
        });
    }
    else{
$('.p-final-price-wrapper .price-additional').each(function () {
                const html = $(this).html();
                const updated = html.replace(bezDPH, '<small>'+bezDPH+'</small>');
                $(this).html(updated);
            });
    }
     

    const customer = getShoptetDataLayer('customer');
    if (customer.registered && customer.priceListId !== 1){
        if (!sessionStorage.getItem('cenikData')) {
            $.getJSON('/user/documents/cenik.json?v='+new Date().getMinutes(), function (data) {
                sessionStorage.setItem('cenikData', JSON.stringify(data));
                showDmocPrice(data);
            });
        } else {
            const data = JSON.parse(sessionStorage.getItem('cenikData'));
            showDmocPrice(data);
        }
    }
    else{
     
    }
    

    // 2. Funkce pro zobrazení DMOC
    function showDmocPrice(data) {
        const productCode = $('.p-detail>.p-detail-inner .p-code span:not(.p-code-label):not(.no-display)').text().trim()
        const found = data.find(p => p.code === productCode);
        if (!found) return;
        const currentPrice = parseFloat($('.p-final-price-wrapper .price-final>span:not(.no-display)').text().replace(',', '.').replace(/[^\d.]/g, ''));
        const dmoc = parseFloat(found.priceVat);
        if (dmoc > currentPrice) {
            $('.p-final-price-wrapper .price-standard').hide();
            const sleva = Math.round(100 - (currentPrice / dmoc * 100));
            $('.p-final-price-wrapper .price-final>span').prepend('<span class="dmoc">'+DMOC+' '+Number(dmoc).ShoptetFormatAsCurrency()+'</span>')
          
        }
    }


    if($('#p-detail-tabs li[data-testid="tabBrand"]').length>0){
        customText = $('#p-detail-tabs li[data-testid="tabBrand"] a').text()
        $('#p-detail-tabs li[data-testid="tabBrand"] a').text(customText)
        $('#manufacturerDescription').prepend('<h3>'+customText+'</h3>')
    };
    if($('.extended-description').length){
        $('#tab-content').append('<div id="additionalParams" class="tab-pane fade additionalParams" role="tabpanel"></div>')
        $('#additionalParams').append($('.extended-description'));
        $('#p-detail-tabs li[data-testid="tabDescription"]').after('<li class="shp-tab" data-testid="tabadditionalParams" data-width=""><a href="#additionalParams" class="shp-tab-link" role="tab" data-toggle="tab">'+Parametry+'</a></li>')
    }
    if($('#ratingTab').length>0){
         $('#ratingTab').prepend('<h3>'+hodnoceni+'</h3>')
    }
    
    if ($("#productVideos").length>0) {
        $('#productVideos').prepend('<h3>Videa</h3>')
        $("#productVideos h3").each(function () {
            var heading = $(this);
            var iframe = heading.next("iframe");
            if (iframe.length) {
                heading.add(iframe).wrapAll('<div class="video-wrapper"></div>');
                iframe.wrap('<div class="iframe-container"></div>');
            }
        });
        

	const $thumbnailsExist = $(".p-thumbnail").length>0;
	if ($thumbnailsExist) {
		createThumbnails();
	} else {
		const $mainImage = $(".p-main-image");
		let ImageHref = $mainImage.attr("href") || "";
		let ImageHrefRel = ImageHref;
		const thumbnailHtml = `
			<div class="p-thumbnails-wrapper">
				<div class="p-thumbnails p-thumbnails-horizontal">
					<div class="p-thumbnails-inner">
						<div>
							<a href="${ImageHref}" class="p-thumbnail highlighted">
								<img data-src="${ImageHrefRel}" width="100" height="100">
							</a>
							<a href="${ImageHref}" class="cbox-gal cboxElement" data-gallery="lightbox[gallery]"></a>
						</div>
					</div>
					<a href="#" class="thumbnail-prev"></a>
					<a href="#" class="thumbnail-next"></a>
				</div>
			</div>
		`;

		$(".p-image-wrapper .p-image").after(thumbnailHtml);
		createThumbnails();
	}
}



    $('.products-additional .product').each(function() {
        $(this).find('.p-tools').append('<a href="'+$(this).find('a.image').attr('href')+'" class="detailButton"></a>')
    });
    $('.p-detail-inner').after('<div class="additionalBuy"></div>');
    if($('.products-related.products-additional').length){
        $('.additionalBuy').append($('.products-related.products-additional'))
    }
    if($('#productsAlternative').length){
        $('.additionalBuy').append($('.products-additional.products-alternative'))
    }

    const brandEl = $('a[data-testid="productCardBrandName"] span');
    if (brandEl.length) {
        const brandText = brandEl.text().trim();

        if (allowedBrands.includes(brandText)) {
            $('.p-info-wrapper').append('<div class="businessInfo"><p>'+detailMessage+'</p></div>')
        } else {
            console.log('Značka není v seznamu povolených:', allowedBrands);
        }
    } else {
        console.log('Element se značkou nebyl nalezen.');
    }

    

    if($('.stars-wrapper .stars .star.star-on').length>0){
        $('.stars-wrapper').append('<div class="verified">Ověřené</div>')
    }
    $('.p-detail-info').append($('.p-detail-inner-header .p-code'));
    $('.stars-label').each(function() {
        var text = $(this).text();
        if (text.indexOf('(Již jste hlasovali)') !== -1) {
            $(this).text(text.replace('(Již jste hlasovali)', ''));
        }
    });
    $('.parameter-dependent').each(function(){
        if($(this).text().trim() === zvolte){
            $(this).text(dleVarianty)
        }
    })
    $('.p-image').append($('.product-top .col-xs-12:not(.col-lg-6) .flags-default').clone())

     $('.p-info-wrapper').append('<div class="stockLine"></div>')
     $('.stockLine').append($('.p-info-wrapper .availability-value'))
    if($('.p-info-wrapper .delivery-time').length){
        $('.p-info-wrapper .delivery-time').closest('tr').hide();
        $('.stockLine').append($('.p-info-wrapper .delivery-time').closest('th').html());
    }
    else{
        $('.shipping-options').closest('tr').hide();
        $('.stockLine').append($('.p-info-wrapper .shipping-options'));
    }
   
   
    
    
    $('.p-info-wrapper').append('<div class="customCart"><div class="inner"></div></div>')
    $('.customCart .inner').prepend($('.p-info-wrapper .p-final-price-wrapper'), $('.p-info-wrapper .add-to-cart'))
    $('.p-info-wrapper').append($('.p-detail .p-detail-inner .p-detail-inner-header').clone(), $('.p-detail .p-detail-inner .product-top .col-xs-12:not(.col-lg-6) .p-detail-info').clone())
   
    const jsonUrl = '/user/documents/blogArticles.json';
    const domainName = window.location.hostname.replace(/^www\./, '');
    const storageKey = 'blogArticlesJson_' + domainName;
    function loadArticlesJson(callback) {
        const cached = sessionStorage.getItem(storageKey);
        if (cached) {
            try {
                const data = JSON.parse(cached);
                return callback(data);
            } catch (e) {
                sessionStorage.removeItem(storageKey);
            }
        }
        $.getJSON(jsonUrl, function (data) {
            sessionStorage.setItem(storageKey, JSON.stringify(data));
            callback(data);
        }).fail(function () {
            console.error('Nepodařilo se načíst JSON.');
        });
    }
function processProductArticles(articles) {
    const $rows = $(".extended-description .detail-parameters tr");
    let urls = [];

    $rows.each(function () {
        const $th = $(this).find("th");
        if ($th.text().trim().startsWith("Články do produktu")) {
            $(this).closest('tr').hide();
            const $td = $(this).find("td");
            const text = $td.text().trim();
            urls = text.split(',').map(url => url.trim()).filter(Boolean);
        }
    });

    if (!urls.length) return;
    $('#p-detail-tabs li[data-testid="tabRating"]').after('<li class="shp-tab" data-width=""><a href="#recepty" class="shp-tab-link">'+Recepty+'</a></li>')
    const isLocalhost = window.location.hostname === 'localhost';
    const domain = window.location.origin;

    const matchedArticles = articles.filter(article => {
        let articlePath = article.link;

        if (isLocalhost) {
            try {
                const parsed = new URL(article.link);
                articlePath = parsed.pathname;
            } catch (e) {
                console.warn('Neplatná URL v JSONu:', article.link);
                return false;
            }
            return urls.includes(articlePath);
        } else {
            return urls.some(u => article.link === domain + u);
        }
    });

    if (!matchedArticles.length) return;

    const $target = $("#tab-content");
    const $container = $('<div class="related-articles" id="recepty"><div class="homepage-group-title h4">'+clankyKProduktu+'</div><div class="newsItems"></div></div>');

    matchedArticles.forEach(article => {
        const item = `
            <div class="news-item">
                <div class="image">
                    <a href="${article.link}"><img src="${article.image}" alt="${article.title}"></a>
                </div>
                <div class="text">
                    <a href="${article.link}" class="title" target="_blank">${article.title}</a>
                    <div class="description"><p>${article.description}</p></div>
                </div>
            </div>`;
        $container.find(".newsItems").append(item);
    });

    $target.append($container);
}


    loadArticlesJson(processProductArticles);


const helpJsonUrl = '/user/documents/helpArticles.json?v='+new Date().getMinutes();
const helpDomainName = window.location.hostname.replace(/^www\./, '');
const helpStorageKey = 'helpArticlesJson_' + helpDomainName;

function loadHelpgArticlesJson(callback) {
    const cached = sessionStorage.getItem(helpStorageKey);
    if (cached) {
        try {
            const data = JSON.parse(cached);
            return callback(data);
        } catch (e) {
            sessionStorage.removeItem(helpStorageKey);
        }
    }

    $.getJSON(helpJsonUrl, function (data) {
        sessionStorage.setItem(helpStorageKey, JSON.stringify(data));
        callback(data);
    }).fail(function () {
        console.error('❌ Nepodařilo se načíst helpArticles.json.');
    });
}

function processProductHelpgArticles(articles) {
    const $rows = $(".extended-description .detail-parameters tr");
    let helpUrls = [];

    $rows.each(function () {
        const $th = $(this).find("th");
        if ($th.text().trim().startsWith(poradit)) {
            $(this).closest('tr').hide();
            const $td = $(this).find("td");
            const text = $td.text().trim();
            helpUrls = text.split(',').map(url => url.trim()).filter(Boolean);
        }
    });

    if (!helpUrls.length) return;
    const isLocalhost = window.location.hostname === 'localhost';
    const domain = window.location.origin;

    const matchedHelpgArticles = articles.filter(article => {
        let articlePath = article.link;

        if (isLocalhost) {
            try {
                const parsed = new URL(article.link);
                articlePath = parsed.pathname;
            } catch (e) {
                console.warn('⚠️ Neplatná URL v JSONu:', article.link);
                return false;
            }
            return helpUrls.includes(articlePath);
        } else {
            return helpUrls.some(u => article.link === domain + u);
        }
    });

    if (!matchedHelpgArticles.length) return;

    const $target = $(".sidebar-inner");
    matchedHelpgArticles.forEach(article => {
        const item = `
            <div class="helpLine">
                <p class="titleTop">${titlePoradit}</p>
                <p class="descriptionTop">${dotazy}</p>
                <div class="helpRow">
                    <div class="image">
                        <img src="${article.image}" alt="${article.title}">
                    </div>
                    <div class="text">
                        <div class="title"><p>${article.title}</p></div>
                        <div class="description">${article.description}</div>
                    </div>
                </div>
            </div>`;
           $target.append(item)
    });

}

// Spuštění
loadHelpgArticlesJson(processProductHelpgArticles);



    

    if ($('.p-thumbnails-wrapper .p-thumbnails-inner').length) {
        
        $('.p-image-wrapper').addClass('haveThumbnails')
        $('.p-image-wrapper').append('<span class="arrow-prev"></span><span class="arrow-next"></span>');
    
        $('body').on('click', '.arrow-prev, .arrow-next', function () {
            var thumbnails = $('.p-thumbnails-inner').find('a.p-thumbnail, a.show360image');
            var highlightedThumbnail = $('.p-thumbnails-inner').find('a.highlighted');
            var isNext = $(this).hasClass('arrow-next');
            var totalThumbnails = thumbnails.length;
            var currentIndex = thumbnails.index(highlightedThumbnail);
            thumbnails.removeClass('highlighted');
            if (highlightedThumbnail.length === 0) {
                highlightedThumbnail = isNext ? thumbnails.first() : thumbnails.last();
            } else {
                currentIndex = isNext ? (currentIndex + 1) % totalThumbnails : (currentIndex - 1 + totalThumbnails) % totalThumbnails;
                highlightedThumbnail = thumbnails.eq(currentIndex);
            }
            highlightedThumbnail.addClass('highlighted');
            setTimeout(function () {
                updateMainImage(highlightedThumbnail);
            }, 10);
        });
      
       
    
    }

    function updateMainImage(highlightedThumbnail) {
        var findHighlighted = highlightedThumbnail.attr('href');
        var findHighlightedAlt = highlightedThumbnail.find('img').attr('alt');
        $('.p-image a.p-main-image').attr('href', findHighlighted).find('img').attr({'src': findHighlighted, 'alt': findHighlightedAlt});
    }


    



    if(!$('#simple-variants').length){
        if($('.variant-list, .surcharge-list').length>0){
            $('.variant-list select, .surcharge-list select').each(function(){
                if($(this).closest('.surcharge-list').find('th .show-tooltip').length){
                    var listTootip = $(this).closest('.surcharge-list').find('th .show-tooltip').attr('title')
                }
                else{
                    listTootip = ''
                }
                var optionLength = $(this).find('option').length
                var data_parameter_id = $(this).data('parameter-id')
                var html_var = '<div class="custom-variant" data-groupId="'+data_parameter_id+'"><div class="h3">'+$(this).attr('data-parameter-name')+'</div>'
                html_var += '<div class="custom-variant-wrap" data-param-id="'+data_parameter_id+'">'
                $(this).find('option').each(function(){
                    var data_value = $(this).attr('value')
                    var skipVariant = false;
                    if (getShoptetDataLayer('product').currentCategory.startsWith("Jednorázové obaly") && data_value == 325) {
                         skipVariant = true;
                    }
                    if (typeof dataLayer !== 'undefined' &&
                        getShoptetDataLayer('customer').registered === true &&  getShoptetDataLayer('customer').groupId === 11 && data_value == 328) {
                        skipVariant = true;
                    }
                   
                    if (skipVariant) return;
                    if($(this).closest('td').find('select[name*="parameterValueId"]').length){
                       
                        if ($.isNumeric($(this).val())) {
                            var textsplit = $(this).text().split('+')
                            html_var += '<div class="variant haveVariant" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                            html_var += '<div class="text">'
                            if(typeof textsplit[1] === 'undefined'){
                                html_var += textsplit[0]
                            }
                            else{
                                html_var += textsplit[0]+' (+'+textsplit[1]+')'
                            }
                          
                            if(listTootip !== ''){
                                if(textsplit[1] !== '0 Kč'){
                                    html_var += '<span class="show-tooltip question-tooltip" title="'+listTootip+'">?</span>'
                                }
                            }
                            html_var += '</div>'
                            html_var += '</div>'
                        }
                    }
                    else{
                      
                        if ($.isNumeric($(this).val())) {
                            
                            var textsplit = $(this).text().split('+')
                            html_var += '<div class="variant haveSurcharge show-tooltip" title="'+$(this).text()+'" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                            html_var += '<div class="image"><img src="/user/documents/upload/obrazky/detail/priplatky/'+data_value+'.svg?v='+new Date().getMinutes()+'" alt="'+$(this).text()+'"></div>'
                            html_var += '</div>'
                        }
                    }
                    
                })
                html_var += '</div>'
                html_var += '</div>'
                $(this).after(html_var)
                $(this).closest('.variant-list select, .surcharge-list select').hide()
               $(this).closest('.variant-list span, .surcharge-list span').hide()
              
            })
    
            /*var necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;
            for (var parentKey in necessaryVariantData) {
                if (necessaryVariantData.hasOwnProperty(parentKey)) {
                    var variant = necessaryVariantData[parentKey];
                    console.log(variant)
                    $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').addClass('haveImage').attr('data-code', variant.code).attr('data-price-id', variant.id).attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-')).append('<span class="dataStock" notSoldOut="'+variant.isNotSoldOut+'"></span>')
                
                }
            }*/

            const storageKey = 'productsProperties';

            if (sessionStorage.getItem(storageKey)) {
                try {
                    const cachedData = JSON.parse(sessionStorage.getItem(storageKey));
                    initVariantAttributeEnhancer(cachedData);
                } catch (e) {
                    console.warn('Chyba při čtení dat ze storage:', e);
                }
            } else {
                $.getJSON('/user/documents/products-properties.json', function (data) {
                    sessionStorage.setItem(storageKey, JSON.stringify(data));
                    initVariantAttributeEnhancer(data);
                }).fail(function () {
                    console.error('❌ Nepodařilo se načíst JSON z /user/documents/products-properties.json');
                });
            }
            
        }
    }

    function initVariantAttributeEnhancer(productsData) {
        const codeToProduct = {};
        productsData.forEach(p => {
            if (p.code) codeToProduct[p.code] = p;
        });

        const necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;

        for (const parentKey in necessaryVariantData) {
            if (!Object.prototype.hasOwnProperty.call(necessaryVariantData, parentKey)) continue;

            const variant = necessaryVariantData[parentKey];
            const $el = $('.custom-variant-wrap .variant[data-param-val="' + parentKey + '"]');
            if (!$el.length) continue;

            const label = $el.find('.text').text().trim().toLowerCase();

            // Základní data
            $el.addClass('haveImage')
                .attr('data-code', variant.code)
                .attr('data-price-id', variant.id)
                .attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-'))
                .find('.text').append('<span class="dataStock" notSoldOut="' + variant.isNotSoldOut + '"></span>');

            const product = codeToProduct[variant.code];
            if (!product || !product.attributes) continue;

            for (const key in variantLabelToAttribute) {
                if (label.includes(key.toLowerCase())) {
                    const possibleAttributes = variantLabelToAttribute[key];
                    for (const attr of possibleAttributes) {
                        const value = product.attributes[attr];
                        if (value) {
                            $el.append('<span class="attributeInfo">Obsahuje: <strong>' + value + '</strong></span>');
                            break;
                        }
                    }
                    break;
                }
            }
        }
    }
    

    $(document).on('click', '.custom-variant-wrap .variant', function(){
        const variantData = $(this).data('value');
        const variantParameterId = $(this).data('parameter-id');
    
        // Změna pro data-parameter-id 281 a třídu active
       
            // Původní chování pro ostatní případy
            $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){
                return $(this).attr('value') == variantData;
            }).change().prop("selected", true);
            $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
            $(this).addClass("active"); 
        
    
        var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
        var $splitParameters = $(selector);
        $splitParameters.trigger('change');
    
       // $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
       // $(this).addClass("active");    
    
        $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
    
        $('.custom-variant-wrap .variant').each(function(){
            const variantData = $(this).data('value');
            const variantParameterId = $(this).data('parameter-id');
            const unavailable = $("select[data-parameter-id='"+variantParameterId+"'] option[value='" + variantData + "']").hasClass("unavailable-option");
            if (unavailable === true) {
                $(this).addClass("unavailable").removeClass("active");
            }
            else{
                $(this).removeClass("unavailable");
            } 
        });
    });

    $(document).on('click', '#jsUnavailableCombinationMessage a', function(){
        $('.custom-variant-wrap .variant').removeClass('unavailable')
    })
    $(document).ready(function(){
     /*   if(getShoptetDataLayer('product').currentCategory.startsWith("Jednorázové obaly")){
            $('.custom-variant-wrap .variant').first().trigger('click');
        }*/
        $(".custom-variant-wrap").each(function() {
            var $variants = $(this).find("div.variant");
            if ($variants.length === 1) {
             // $variants.addClass("active");
            }
          });
        var urlParams = new URLSearchParams(window.location.search);
        var parameterValueId = urlParams.get("parameterValueId");
        var $divToHighlight = $("div.variant[data-value='" + parameterValueId + "']");
        if ($divToHighlight.length > 0) {
            $divToHighlight.addClass("active");
        }
    })
   
}

$('html').on("click", ".customVideo", function(e) {
        var iframeClone = '<div class="popupVideoColorBox">'
        iframeClone += $(this).find('iframe').prop('outerHTML')
        iframeClone += '</div>'
        $.colorbox({
            html: iframeClone,
            width: 700,
            maxWidth: "95%",
            height: 400,
            maxHeight: "95%",
            className: "colorboxIframe",
            onComplete: function() {
                
            }
        })
})


function createThumbnails() {
	$("#productVideos iframe").first().each(function () {
		const $originalIframe = $(this);
		const videoSrc = $originalIframe.attr("data-iframe-src") || "";
		const videoId = videoSrc.split("embed/")[1]?.split("?")[0] || "";
		const videoBgUrl = `url(https://img.youtube.com/vi/${videoId}/0.jpg)`;
		const $clonedIframe = $originalIframe.clone();
		const overlayHtml = `
			<div class="iframe-overlay" style="background-image: ${videoBgUrl}">
				<img src="/user/documents/upload/sablona-nemazat/ico-youtubeframe.svg">
			</div>
		`;

		const $videoWrapper = $('<a class="p-thumbnail customVideo" href="https://img.youtube.com/vi/'+videoId+'/0.jpg" />')
			.append($clonedIframe)
			.prepend(overlayHtml);

		$videoWrapper.insertAfter(".p-thumbnail:first + a");

		$originalIframe.attr("src", videoSrc);
		$clonedIframe.attr("src", videoSrc);
	});
}